import { Navigate, useLocation } from 'react-router-dom';
import storage from '../Assets/js/Global';

const ProtectedRoute = ({ children, company }) => {
    const location = useLocation();
    const loginObj = storage.get('loginObj');

    const isAuthenticated = loginObj && loginObj.userKey;
    const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Restrict company-specific routes to their own company's dashboard
    if (company === '4life' && !is4Life) {
        return <Navigate to="/dashboard" replace />;
    }
    if (company === 'globalhealth' && is4Life) {
        return <Navigate to="/dashboard2" replace />;
    }

    return children;
};

export default ProtectedRoute;